import benefitsDataFr from '../data/BenefitsData/benefitsDataFr';
import { LangData } from '../types/langTypes';

const fr: LangData = {
  id: "fr",
  name: "Français",
  images: [],
  altText: "Image de la langue française",
  description: "Traduction française pour l'application.",
  portfolioDescription1: "Site web responsive en one-page pour une marque de glace : présente les produits, une section « comment c’est fait », une galerie et un formulaire de contact. Construit en HTML, CSS (mobile-first) et JavaScript.",
  portfolioDescription2: "Une application web e-commerce moderne et responsive, dotée d’une interface UI/UX épurée, de filtres produits en temps réel, de gestion de panier et d’un design mobile-first. Technologies utilisées : React, TypeScript, Redux et SCSS.",
  portfolioDescription3: "",
  portfolioDescription4: "",
  portfolioDescription5: "",
  portfolioDescription6: "",
  portfolioDescription: 'Description du portfolio',
  backToTop: 'Retour en haut',
  mainNavigationLabel: "Navigation principale",
  mainNavigation: ['Accueil', 'À propos', 'Services', 'Portfolio', 'Contact'],
  logoTaglines: {
    top: "Ose penser",
    bottom: "Crée intelligemment",
  },
  home: "Accueil",
  about: "À propos",
  aboutmain: "À propos",
  aboutTitle: "À PROPOS DE NOUS",
  aboutSubtitle: "Architectes de la supériorité numérique",
  aboutText: "SYDRIX est le point de rencontre entre l'esthétique de l'ingénierie et l'efficacité commerciale. Fondé par un visionnaire ukrainien au cœur de la Bavière, notre studio incarne la résilience numérique et l'innovation. Nous concevons des actifs numériques qui anticipent les besoins du marché. Notre approche repose sur trois piliers : Performance-First (la vitesse comme religion), Inclusive Design (l'accessibilité comme standard) et Scalable Architecture (prêt pour une croissance décuplée). Nous croyons que le code parfait doit être invisible, mais le résultat doit être tangible dans chaque rapport de profit. Avec SYDRIX, vous obtenez un avantage technologique qui transforme votre marque en leader de l'ère numérique.",
  aboutPhilosophyTitle: "Notre Philosophie",
  aboutPhilosophyText: "Nous remplaçons les méthodes obsolètes par une vision moderne de la performance. Notre approche garantit une architecture durable.",
  aboutButton: "En savoir plus",
  aboutButtonText: "Voir",
  aboutButtonLink: "/about",
  aboutImageAlt: "Image à propos de nous",
  aboutList: ["Équipe professionnelle", "Technologies modernes", "Approche individuelle"],
  aboutQuote: "Nous aimons ce que nous faisons !",
  aboutQuoteAuthor: "Fondateur de l'équipe",
  aboutStats: [
    { label: "Stack technique", value: "Next.js" },
    { label: "Focus qualité", value: "100%" }
  ],
  aboutMission: "Nous transformons des technologies complexes en vos actifs stratégiques, assurant le leadership de votre entreprise.",
  aboutVision: "Devenir la référence mondiale de l'ingénierie frontend, où chaque pixel travaille pour le profit du client.",
  aboutValues: ["Excellence technique", "Transparence radicale", "Innovations évolutives"],
  aboutTeam: "Notre équipe est notre principal atout.",
  aboutPartners: "Nos partenaires nous font confiance.",
  aboutClients: "Nos clients sont nos amis.",
  aboutHistory: "L'histoire de l'entreprise a commencé en 2025.",
  services: "Services",
  servicesTitle: "Nos services",
  servicesContactText: "Contactez-nous pour plus de détails",
  servicesButton: "En savoir plus",
  servicesFormTitle: "Obtenez une consultation gratuite",
  servicesFormPlaceholder: "Votre e-mail",
  servicesFormButton: "Envoyer",
  showLessButton: "Afficher moins",
  showMoreButton: "Afficher plus",

  portfolio: "Portfolio",
  portfolioTitle: "Portfolio",
  portfolioText: "Idées concrétisées",
  portfolioLabel: "Portfolio",
  viewOnGithub: "Voir sur GitHub",
  noProjectsFound: "Aucun projet trouvé.",

  testimonials: "Témoignages",
  testimonialsText: "Merci à tous nos clients pour leurs retours !",
  blogTitle: "Blog",
  contacts: "Contacts",
  contactsTitle: "Contacts",
  phone: "Téléphone",
  email: "E-mail",
  faq: "FAQ",
  partnership: "Partenariat",
  showAllButton: "Tout afficher",
  hideAllButton: "Masquer",
  title: "Développement frontend pour votre entreprise",
  subtitle: [
    "Une vitesse impressionnante.",
    "Un design mémorable.",
    "Une expérience captivante."
  ],
  button: "Discutons",
  benefitsTitle: "Les avantages de travailler avec nous",
  benefitsSubtitle: "Pourquoi nos clients nous choisissent",
  benefitsText: "Nous créons des sites rapides, sécurisés et efficaces.",
  benefits: benefitsDataFr,
  goTo: "aller à",
  footer: "Développé par Artem Sydorov",
  heroTitle: "Développement frontend pour votre entreprise",
  heroSubtitle: [
    "Une vitesse impressionnante.",
    "Un design mémorable.",
    "Une expérience captivante."
  ],
  heroButton: "Discutons",
  portfolioLink: "/portfolio",
  portfolioLinkText: "Voir le portfolio",

  serviceDetailsTitle: "Détails du service",
  serviceDetailsText: "Informations détaillées sur nos services.",
  servicesDetailsButton: "Plus d'informations sur le service",
  servicesDetailsSubtitle: "En savoir plus sur nos services",
  servicesDetailsList: ["Service 1", "Service 2", "Service 3"],
  notFoundTitle: "Page non trouvée",
  notFoundText: "Désolé, cette page n'existe pas.",
  notFoundButton: "Retour à l'accueil",
  cookieConsentText: "Ce site utilise des cookies pour améliorer votre expérience utilisateur.",
  cookieConsentButton: "Compris",
  privacyPolicy: "Politique de confidentialité",
  termsOfService: "Conditions d'utilisation",
  loading: "Chargement...",
  error: "Une erreur s'est produite. Veuillez réessayer.",
  success: "Succès !",
  language: "Langue",
  selectLanguage: "Choisissez la langue",
  close: "Fermer",

  serviceDetailsBack: "Retour aux services",
  faqTitle: "Foire aux questions",
  faqSubtitle: "Réponses aux questions les plus fréquentes",
  faqText: "Si vous avez une question, consultez cette section ou contactez-nous.",
  team: "Équipe",
  teamTitle: "Notre équipe",
  teamText: "Nous sommes une équipe de professionnels passionnés.",
  process: "Processus",
  processTitle: "Notre façon de travailler",
  processText: "Nous suivons un processus de développement transparent.",
  technologies: "Technologies",
  technologiesTitle: "Technologies que nous utilisons",
  technologiesText: "Nous utilisons des frameworks et outils modernes.",
  price: "Prix",
  priceTitle: "Nos tarifs",
  priceText: "Découvrez les prix de nos services.",

  processSubtitle: "Étapes de notre travail",
  teamSubtitle: "Rencontrez notre équipe",
  teamButton: "En savoir plus sur l'équipe",
  teamButtonText: "Voir l'équipe",
  processButton: "En savoir plus sur le processus",
  processButtonText: "Voir le processus",
  technologiesSubtitle: "Nos technologies",
  technologiesButton: "En savoir plus sur les technologies",
  technologiesButtonText: "Voir les technologies",
  priceSubtitle: "Détails des prix",
  priceButton: "En savoir plus sur les prix",
  priceButtonText: "Voir les prix",

  teamButtonLink: "/team",
  portfolioButton: "Plus sur le portfolio",
  portfolioButtonText: "Voir le portfolio",
  portfolioButtonLink: "/portfolio",
  blogButton: "En savoir plus sur le blog",
  blogButtonText: "Voir le blog",
  blogButtonLink: "/blog",
  contactsButton: "En savoir plus sur les contacts",
  contactsButtonText: "Voir les contacts",
  contactsButtonLink: "/contacts",
  faqButton: "En savoir plus sur la FAQ",
  faqButtonText: "Voir la FAQ",
  faqButtonLink: "/faq",
  notFoundButtonText: "Retour à l'accueil",
  cookieConsentMore: "En savoir plus",
  privacyPolicyButton: "Voir la politique",
  termsOfServiceButton: "Voir les conditions",

  contactsButtonLinkText: "Aller aux contacts",
  cookieConsentLink: "/privacy-policy",
  privacyPolicyButtonText: "Voir la politique de confidentialité",
  termsOfServiceButtonText: "Voir les conditions d'utilisation",
  aboutButtonLinkText: "Plus d'infos sur nous",
  servicesButtonLinkText: "Plus d'infos sur les services",
  portfolioButtonLinkText: "Plus d'infos sur le portfolio",
  blogButtonLinkText: "Plus d'infos sur le blog",
  faqButtonLinkText: "Plus d'infos sur la FAQ",
  teamButtonLinkText: "Plus d'infos sur l'équipe",
  processButtonLinkText: "Plus d'infos sur le processus",
  technologiesButtonLinkText: "Plus d'infos sur les technologies",
  priceButtonLinkText: "Plus d'infos sur les prix",
  notFoundButtonLinkText: "Retour à l'accueil",
  cookieConsentButtonText: "Compris",
  cookieConsentMoreText: "En savoir plus",

  faqQuestion: "Question",
  faqAnswer: "Réponse",
  priceButtonLink: "/price",
  processButtonLink: "/process",
  technologiesButtonLink: "/technologies",
  servicesButtonLink: "/services",
  notFoundButtonLink: "/",
  privacyPolicyLink: "/privacy-policy",
  termsOfServiceLink: "/terms-of-service",

  partnershipTitle: "Partenariat",
  partnershipSubtitle: "Opportunités de collaboration",
  partnershipText: "Nous sommes ouverts aux partenariats et aux nouvelles opportunités de collaboration.",
  notFoundBackButton: "Retour",
  extraField1: "Champ supplémentaire 1",
  extraField2: "Champ supplémentaire 2",
  notFoundLink: "/",
  cookieConsent: "Ce site utilise des cookies pour améliorer votre expérience utilisateur.",
  toggleMenu: "Basculer le menu",
  noPortfolioItems: 'Le portfolio est actuellement vide',
  noImages: 'Aucune image disponible',
  "impressum.back": "Retour",
  "impressum.subtitle": "Mentions Légales",
  "impressum.infoTitle": "Informations selon § 5 TMG",
  "impressum.owner": "Propriétaire",
  "impressum.address": "Hochriesstraße 29",
  "impressum.city": "83209 Prien am Chiemsee, Allemagne",
  "impressum.contactTitle": "Contact",
  "impressum.email": "E-mail",
  "impressum.website": "Site web",
  "impressum.copyrightTitle": "Droit d'auteur",
  "impressum.rights": "Tous droits réservés.",
  "impressum.disputeTitle": "Règlement des litiges",
  "impressum.disputeText": "La Commission européenne propose une plateforme de règlement des litiges en ligne (OS) :",
  "impressum.disputeFinal": "Je ne suis pas obligé de participer à une procédure de règlement des litiges devant un conseil d'arbitrage.",
  "impressum.disclaimerTitle": "Clause de non-responsabilité",
  "impressum.disclaimerText": "Responsabilité relative au contenu : Le contenu de nos pages a été élaboré avec le plus grand soin. Toutefois, nous ne pouvons garantir l'exactitude ou l'exhaustivité des informations. En tant que prestataire de services, nous sommes responsables de nos propres contenus sur ces pages. Responsabilité relative aux liens : Notre offre contient des liens vers des sites web externes de tiers sur lesquels nous n'avons aucune influence et ne pouvons être tenus responsables.",
  "impressum.taxStatus": "Conformément au § 19 UStG, la TVA n'est pas facturée (statut de petite entreprise).",
  "impressum.responsible": "Responsable du contenu selon le § 18 MStV",
  "impressum.phone": "Téléphone",
  "impressum.copyrightText": "Le contenu et les œuvres créés par l'exploitant du site sur ces pages sont soumis au droit d'auteur. Toute reproduction, modification ou distribution au-delà des limites du droit d'auteur nécessite l'accord écrit de l'auteur.",
  "impressum.copyrightLinkText": "Loi allemande sur le droit d'auteur (UrhG)",

  "privacy.title": "Politique de confidentialité",
  "privacy.intro": "Je prends la protection de vos données personnelles très au sérieux. Ce site web est conçu pour traiter le moins de données possible.",
  "privacy.hostingTitle": "1. Hébergement externe",
  "privacy.hostingText": "Ce site web est hébergé par un prestataire de services externe (hébergeur). Les données personnelles collectées sur ce site sont stockées sur les serveurs de l'hébergeur. Cela comprend principalement les adresses IP et les métadonnées. L'utilisation de l'hébergeur est faite dans l'intérêt d'une fourniture sûre et rapide de notre service en ligne par un fournisseur professionnel (Art. 6 al. 1 lit. f RGPD).",
  "privacy.dataTitle": "2. Minimisation des données",
  "privacy.dataText": "Dans un esprit de minimisation des données, ce site s'abstient d'utiliser des cookies, des outils d'analyse (tracking) et des formulaires de contact. Aucune évaluation de votre comportement d'utilisateur n'est effectuée.",
  "privacy.rightsTitle": "3. Droits de la personne concernée",
  "privacy.rightsText": "Dans le cadre des dispositions légales en vigueur, vous avez à tout moment le droit d'obtenir gratuitement des informations sur vos données personnelles stockées, ainsi qu'un droit de rectification ou de suppression de ces données.",
  "privacy.contactTitle": "4. Responsable du traitement",
  "privacy.contactText": "Le responsable du traitement des données est Artem Sydorov. Les coordonnées complètes se trouvent dans les mentions légales (Impressum) de ce site.",
};

export default fr;
